// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#opusmap .linked-resource {\n  padding: 5px;\n  margin-bottom: 20px;\n}", "",{"version":3,"sources":["webpack://./src/styles/css/LinkedResourcesPopup.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["#opusmap .linked-resource {\n  padding: 5px;\n  margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
